import React, { useState } from 'react'

import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'

import ExpandedListHR from 'components/styled/ExpandedListHR'

// local components
import ShowMoreContent from './components/ShowMoreContent'

function DownloadsExpandedList({
  children,
  expanded,
  rowData,
  statusTitle = '',
  getDataDisplay,
  collapseDetails,
}) {
  const { request_parameters: metadata } = rowData ?? {}
  const gridWidth = 12

  const [open, setOpen] = useState(false)

  return (
    <Collapse
      in={expanded}
      sx={{
        textAlign: 'left',
        px: 11,
        pt: 2,
        mt: 0,
        '& .MuiCollapse-entered': {
          mt: 4,
        },
      }}
    >
      {statusTitle && (
        <Typography fontWeight="bold" fontSize={14}>
          {statusTitle}
        </Typography>
      )}
      <Grid container columns={gridWidth} spacing={30}>
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography fontWeight="medium" fontSize={14}>
              Details
            </Typography>
            {collapseDetails && (
              <IconButton onClick={() => setOpen(!open)}>
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            )}
          </Box>
          <ExpandedListHR />
          <ShowMoreContent
            grid
            rowData={metadata}
            columns={Object.keys(metadata || {}).map((key) => ({
              id: key,
              display: key,
            }))}
            visibleColumns={[]}
            open={true}
            getDataDisplay={getDataDisplay}
          />
        </Grid>
      </Grid>
      {children}
    </Collapse>
  )
}

export default DownloadsExpandedList
